'use client';

import './block-guide-animation.css';

// ============================================================================
// BLOCK GUIDE ANIMATION — BEHANCE LONGREAD STYLE
// ============================================================================
// One continuous vertical strip. No gaps between blocks. Edge-to-edge media.
// Content is clipped to the rounded canvas shape.

export function BlockGuideAnimation() {
  return (
    <div className="block-guide" aria-hidden="true">
      <svg
        viewBox="0 0 240 480"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="block-guide__svg"
      >
        {/* Clip path — rounded canvas shape */}
        <defs>
          <clipPath id="canvas-clip">
            <rect x="8" y="8" width="224" height="464" rx="12" />
          </clipPath>
        </defs>

        {/* Canvas outline */}
        <rect
          className="bg-canvas"
          x="8"
          y="8"
          width="224"
          height="464"
          rx="12"
        />

        {/* ================================================================ */}
        {/* ALL CONTENT — clipped to canvas                                  */}
        {/* ================================================================ */}
        <g clipPath="url(#canvas-clip)">

          {/* ============================================================== */}
          {/* HEADER — compact top bar                                       */}
          {/* ============================================================== */}
          <rect className="bg-logo" x="20" y="20" width="26" height="26" rx="7" />
          <rect className="bg-name" x="54" y="22" width="82" height="8" rx="4" />
          <rect className="bg-tagline" x="54" y="36" width="58" height="6" rx="3" />

          {/* Divider */}
          <line className="bg-divider" x1="8" y1="58" x2="232" y2="58" />

          {/* ============================================================== */}
          {/* BLOCK 1 — HERO IMAGE (edge-to-edge, no rx, no gap)             */}
          {/* ============================================================== */}
          <rect className="bg-img1-bg" x="8" y="58" width="224" height="110" />

          {/* Landscape scene */}
          <circle className="bg-img1-sun" cx="192" cy="82" r="10" />
          <path
            className="bg-img1-mtn"
            d="M8 168 L56 108 L92 136 L136 92 L180 128 L232 168 Z"
          />
          <path
            className="bg-img1-hill"
            d="M8 168 L52 148 L108 156 L172 140 L232 168 Z"
          />

          {/* ============================================================== */}
          {/* BLOCK 2 — VIDEO (flush against hero, zero gap)                 */}
          {/* ============================================================== */}
          <rect className="bg-vid-bg" x="8" y="168" width="224" height="100" />

          {/* Play circle + triangle */}
          <circle className="bg-vid-play-circle" cx="120" cy="218" r="16" />

          {/* ============================================================== */}
          {/* BLOCK 3 — SECOND IMAGE (flush, zero gap)                       */}
          {/* ============================================================== */}
          <rect className="bg-img2-bg" x="8" y="268" width="224" height="90" />

          {/* UI mockup shapes inside */}
          <rect className="bg-img2-bar bg-img2-bar--1" x="24" y="284" width="80" height="6" rx="3" />
          <rect className="bg-img2-bar bg-img2-bar--2" x="24" y="296" width="56" height="6" rx="3" />
          <rect className="bg-img2-dot bg-img2-dot--1" x="24" y="312" width="32" height="18" rx="4" />
          <rect className="bg-img2-dot bg-img2-dot--2" x="62" y="312" width="32" height="18" rx="4" />
          <rect className="bg-img2-dot bg-img2-dot--3" x="100" y="312" width="32" height="18" rx="4" />

          {/* ============================================================== */}
          {/* BLOCK 4 — TWO IMAGES SIDE BY SIDE (2px gap, flush to edges)    */}
          {/* ============================================================== */}
          <rect className="bg-pair-l" x="8" y="358" width="111" height="90" />
          <rect className="bg-pair-r" x="121" y="358" width="111" height="90" />

          {/* Left inner — circle + lines (profile card) */}
          <circle className="bg-pair-l-circle" cx="36" cy="390" r="10" />
          <rect className="bg-pair-l-line bg-pair-l-line--1" x="52" y="386" width="36" height="4" rx="2" />
          <rect className="bg-pair-l-line bg-pair-l-line--2" x="52" y="396" width="28" height="4" rx="2" />

          {/* Right inner — landscape (photo) */}
          <path className="bg-pair-r-shape" d="M121 448 L158 392 L191 414 L232 448 Z" />
          <circle className="bg-pair-r-dot" cx="204" cy="380" r="6" />

          {/* ============================================================== */}
          {/* BLOCK 5 — BOTTOM IMAGE (flush, fills to canvas bottom)         */}
          {/* ============================================================== */}
          <rect className="bg-img3-bg" x="8" y="448" width="224" height="24" />

        </g>

        {/* ================================================================ */}
        {/* CURSOR DOT — outside the canvas, travels along left edge         */}
        {/* ================================================================ */}
        <circle className="bg-cursor" cx="4" cy="58" r="3.5" />
      </svg>
    </div>
  );
}
